import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function ZRangeSection() {

  const [activeFeature, setActiveFeature] = useState(0);

  const features = [
    {
      icon: 'ri-hotel-bed-line',
      title: 'Immersive Stay Experience',
      description: 'Panoramic windows, smart climate control, and premium interior design create an unforgettable living experience'
    },
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'Smart Living Systems',
      description: 'Automated lighting, temperature, and sound insulation for maximum comfort and energy efficiency'
    },
    {
      icon: 'ri-water-flash-line',
      title: 'Complete Bathroom Facilities',
      description: 'Full bathroom with shower, modern fixtures, and efficient water management systems'
    },
    {
      icon: 'ri-funds-line',
      title: 'High ROI Potential',
      description: 'Perfect for short-stay accommodation, glamping sites, and boutique resorts with strong rental income potential'
    }
  ];

  return (
    <section id="z-range" className="relative py-16 sm:py-24 lg:py-32 overflow-hidden w-full">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <div className="inline-flex items-center gap-3 px-4 sm:px-6 py-2 sm:py-3 bg-cyan-500/10 border border-cyan-500/30 rounded-full mb-4 sm:mb-6">
            <div className="w-6 h-6 sm:w-8 sm:h-8 bg-cyan-500/20 rounded-full flex items-center justify-center">
              <span className="text-base sm:text-lg font-bold text-cyan-400">Z</span>
            </div>
            <span className="text-cyan-400 text-xs sm:text-sm uppercase tracking-widest">Z Series</span>
          </div>
          <h2 className="text-3xl sm:text-5xl lg:text-6xl font-thin mb-4 sm:mb-6 px-4">
            Future Living <span className="text-cyan-400">Capsules</span>
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-400 max-w-3xl mx-auto px-4">
            Space capsule–style living units designed for luxury accommodation and immersive stay experiences
          </p>
        </div>

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center mb-12 sm:mb-16 lg:mb-20 w-full">
          {/* Left: Image */}
          <div className="relative order-1 w-full">
            <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/20 to-blue-500/20 blur-3xl rounded-full"></div>
            <div className="relative w-full h-[400px] sm:h-[500px] lg:h-[600px]">
              <img 
                src="/images/ai-futuristic-space-capsule-living-pod-with-99909a.webp" 
                alt="Z Range Living Capsule"
                className="w-full h-full object-cover rounded-3xl"
              />
            </div>
          </div>

          {/* Right: Features */}
          <div className="space-y-4 sm:space-y-6 order-2 w-full">
            {features.map((feature, index) => (
              <div
                key={index}
                onMouseEnter={() => setActiveFeature(index)}
                onClick={() => setActiveFeature(index)}
                className={`p-6 sm:p-8 rounded-2xl border transition-all duration-300 cursor-pointer w-full ${
                  activeFeature === index
                    ? 'bg-cyan-500/10 border-cyan-500/50 shadow-[0_0_30px_rgba(0,217,255,0.2)]'
                    : 'bg-white/5 border-white/10 hover:border-cyan-500/30'
                }`}
              >
                <div className="flex items-start gap-4 sm:gap-6">
                  <div className={`w-12 h-12 sm:w-14 sm:h-14 rounded-xl flex items-center justify-center transition-all flex-shrink-0 ${
                    activeFeature === index ? 'bg-cyan-500/20' : 'bg-white/10'
                  }`}>
                    <i className={`${feature.icon} text-xl sm:text-2xl ${activeFeature === index ? 'text-cyan-400' : 'text-gray-400'}`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-lg sm:text-xl font-medium mb-2 text-white">{feature.title}</h3>
                    <p className="text-sm sm:text-base text-gray-400 leading-relaxed">{feature.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Use Cases Grid */}
        {/* Section removed */}

        {/* CTA Button */}
        <div className="text-center w-full flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/z-range-details"
            className="group inline-flex items-center gap-3 px-8 py-4 bg-cyan-500 text-black text-base font-medium rounded-full hover:bg-cyan-400 transition-all hover:shadow-[0_0_30px_rgba(0,217,255,0.6)] whitespace-nowrap cursor-pointer"
          >
            Explore Z Series Details
            <div className="w-8 h-8 bg-black rounded-full flex items-center justify-center group-hover:shadow-[0_0_15px_rgba(0,217,255,0.4)] transition-all">
              <i className="ri-arrow-right-line text-cyan-400"></i>
            </div>
          </Link>
          <Link to="/contact?model=Z%20Series" className="group inline-flex items-center gap-3 px-8 py-4 bg-cyan-600 text-white text-base font-medium rounded-full hover:bg-cyan-500 transition-all hover:shadow-[0_0_30px_rgba(0,217,255,0.6)] whitespace-nowrap cursor-pointer">
            Request Quote for Z Series
            <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center group-hover:shadow-[0_0_15px_rgba(0,217,255,0.4)] transition-all">
              <i className="ri-mail-send-line text-cyan-600"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}